<template>
<div class="container">
    <router-view />
</div>
</template>

<style scoped>

.container{
  position: absolute;
  width: 100%;
  height: 100%;
  display: inline-block;
  
}
 
</style>